import React from 'react'
import IntroSections from '../IntroSections'
import {Link} from 'react-router-dom'



const Login = () => {
  return (
      <>
          
      <IntroSections sectionName="Log In" sectionLink="Log In" />
      <div className='login'>
        
                       <form className='Registration_card'>
            <h3>Log In</h3>      
          
            
                  <label>Username *</label>
                  <input type='text' placeholder='Your Username' className='input' required />    
             
                  <label>Password *</label>        
                  <input type='password' placeholder='Type Password' required className='input'/>     

        <input type='submit' className='btnn' />
              <p className='mt-5'>If you don't have an account with us, please <Link to="/Registration">Registration.</Link></p>
          
          </form>     
</div>





    </>
  )
}

export default Login